import { useEffect, useState } from 'react';
import LoanInfoService from '../../../service/LoanInfo';
import { s } from './CourtInformation.styles';
import Loading from '../../../func/components/loading/LoadingCircle';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/footer/Footer';
const exportIcon = '/assets/images/icon/Icon_Export_gray.svg'
const arrowIcon = '/assets/images/icon/Arrow.svg'
const arrowBottomIcon = '/assets/images/arrow/arrow_down.svg'
const StatusServey = () => {
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState('현황조사내역');
  const [basicInfo, setBasicInfo] = useState<string[][]>([]);
  const [realEstateInfo, setRealEstateInfo] = useState<string[][]>([]);
  const [displayList, setDisplayList] = useState<string[][]>([]);
  const [realEstatOccupancy, setRealEstatOccupancy] = useState<string[][]>([]);
  const [leaseSurvey, setLeaseSurvey] = useState<string[][][]>([]);
  const params = new URLSearchParams(window.location.search);
  const iidx = params.get('iidx');
  const navigate = useNavigate();
  const caseTitle = basicInfo[1]?.[0] || '';
  const match = caseTitle.match(/\d{4}타경\d+/); 

const caseNumber = match ? match[0] : ''; 
  const getData = async (iidx: number) => {
    try {
      setLoading(true);
      const res = await LoanInfoService.statusServey(iidx);
    setBasicInfo(res.data.basic_basic || []);
      setRealEstateInfo(res.data.basic_rent || []);
      setDisplayList(res.data.list_basic || []);
      setRealEstatOccupancy(res.data.real_relation || []);
           
      if (res.data.rent_content) {
        const groupedRentContent = [];

        for (let i = 0; i < res.data.rent_content.length; i += 11) {
          groupedRentContent.push(res.data.rent_content.slice(i, i + 11));
        }
        setLeaseSurvey(groupedRentContent);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (iidx) {
      getData(Number(iidx));
    }
  }, []);

  //&nbsp; 제거
  const cleanedString = (text: any): string => {
    return text
      .replace(/&nbsp;/g, '') // &nbsp; 제거
      .replace(/\n/g, '<br />') // \n을 <br />로 변경
      .trim(); // 양쪽 공백 제거
  };

  //&nbsp; 4개가 <br />로 변경
  const formattedString = (str: string): string => {
    return str.replace(/(&nbsp;){4}/g, '<br />');
  };

  const groupedRentContent = [];
  for (let i = 0; i < leaseSurvey.length; i += 11) {
    groupedRentContent.push(leaseSurvey.slice(i, i + 11));
  }

  return (
    <s.Container>
      {loading && <Loading />}
      {!loading && (
        <s.Inner>
          <TitleWrapper>
            <PageTitleBox>
              <div style={{display:'flex', alignItems: 'center', gap:'6px', letterSpacing:'-0.36px'}}>
                <BackButton onClick={() => window.close()}>
                  <img src={arrowIcon} alt="" />
                </BackButton>
               <div style={{ color: '#222222' }}>
                {basicInfo[1] && basicInfo[1][0]
                  ? (basicInfo[1][0].match(/\d{4}타경\d+/)?.[0] || '')
                  : ''}
                  <span style={{ marginLeft: '8px' }}>현황조사서</span>
              </div>
              </div>
              <IconWrapper>
                <img src={exportIcon} alt="" style={{ width: '24px', height: '24px' }}/>
              </IconWrapper>
              </PageTitleBox>
          </TitleWrapper>
          <div style={{ padding: '32px 16px 16px' }}>
            <DuplicationWrapper>
              <div style={{ display: 'flex', gap: '16px', marginBottom:'16px'}}>
                <div style={{ width:'100%' }}>
                  <DuplicationTitle>법원</DuplicationTitle>
                  <DuplicationBox style={{ background:'none', padding: '10px 0' }}>컨텐츠</DuplicationBox>
                </div>
                <div style={{ width:'100%' }}>
                  <DuplicationTitle>명령회차</DuplicationTitle>
                  <div style={{ display: 'flex', alignItems:'center', gap:'4px' }}>
                  <DuplicationBox style={{ width:'100%' }}>
                    <img src={arrowBottomIcon}
                    style={{ position: 'absolute', right: '12px' }} />
                    </DuplicationBox><span style={{fontSize:'14px', color:'#616161'}}>회</span>
                    </div>
                </div>
              </div>
              <DuplicationTitle>중복/병합사건</DuplicationTitle>
              <DuplicationBox>
                {basicInfo[1] && basicInfo[1][0]
                            ? (basicInfo[1][0].match(/\d{4}타경\d+/)?.[0] || '')
                  : ''}
                <img src={arrowBottomIcon}
                  style={{ position: 'absolute', right: '12px' }} />
              </DuplicationBox>
            </DuplicationWrapper>
            </div>
          <s.TabBox>
            <s.TabBoxInner>
              <s.TabButton
                active={tab === '현황조사내역'}
                onClick={() => setTab('현황조사내역')}
              >
                현황조사내역
              </s.TabButton>
              <s.TabButton
                active={tab === '부동산표시목록'}
                onClick={() => setTab('부동산표시목록')}
              >
                부동산표시목록
              </s.TabButton>
            </s.TabBoxInner>
          </s.TabBox>
          {tab === '현황조사내역' && (
            <>
              <div style={{ paddingBottom: '40px' }}>
              <s.ContentBlock style={{ gap: '0' }}>
                  <s.Content style={{ padding: '0 16px 16px' }}>
                    
                  <s.ContentTitleBox style={{ padding:'24px 0 24px' }}>기본정보</s.ContentTitleBox>
                  <s.Table>
                    <tbody>
                      <s.Row>
                        <s.TitleCell width="110px"> 사건번호</s.TitleCell>
                        <s.ContentCell
                          width="auto"
                          border={true}
                          textAlign="left"
                        >
                          {basicInfo[1]}
                        </s.ContentCell>
                      </s.Row>
                      <s.Row>
                        <s.TitleCell width="110px">조사일시</s.TitleCell>
                        <s.ContentCell
                          width="auto"
                          border={true}
                          textAlign="left"
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: cleanedString(
                                basicInfo[3] && basicInfo[3][0]
                                  ? basicInfo[3][0]
                                  : '',
                              ),
                            }}
                          />
                        </s.ContentCell>
                      </s.Row>
                    </tbody>
                  </s.Table>
                </s.Content>
                <s.Content style={{ padding: '16px' }}>
                  <s.SubContentTitle>부동산임대차정보</s.SubContentTitle>
                  <s.Table>
                    <thead>
                      <s.Row>
                        <s.TableHeadTh width="90px">번호 / 임대차관계</s.TableHeadTh>
                        <s.TableHeadTh width="auto">소재지</s.TableHeadTh>
                      </s.Row>
                    </thead>
                    <tbody>
                      <s.Row>
                        <s.ContentCell
                          width="90px"
                          border={true}
                          textAlign="center"
                          style={{ borderRight: '1px solid #e1e2e4' }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: cleanedString(
                                realEstateInfo[1] && realEstateInfo[1][0]
                                  ? realEstateInfo[1][0]
                                  : '',
                              ),
                            }}
                          />/
                          <span
                            dangerouslySetInnerHTML={{
                              __html: cleanedString(
                                realEstateInfo[1] && realEstateInfo[1][2]
                                  ? realEstateInfo[1][2]
                                  : '',
                              ),
                            }}
                          />
                        </s.ContentCell>
                        <s.ContentCell
                          width="auto"
                          border={true}
                          textAlign="left"
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: cleanedString(
                                realEstateInfo[1] && realEstateInfo[1][1]
                                  ? realEstateInfo[1][1]
                                  : '',
                              ),
                            }}
                          />
                        </s.ContentCell>
                      </s.Row>
                    </tbody>
                  </s.Table>
                </s.Content>
              </s.ContentBlock>
              <s.ContentBlock style={{ padding: '16px', gap:0 }}>
                <s.ContentTitleBox style={{ padding:'0 0 24px' }}>
                  부동산의 현황 및 점유관계 조사서
                </s.ContentTitleBox>
                <s.Content>
                  <s.SubContentTitle>1. 부동산의 점유관계</s.SubContentTitle>
                  <s.Table>
                    <tbody>
                      <s.Row>
                        <s.TitleCell width="110px">소재지</s.TitleCell>
                        <s.ContentCell
                          width="auto"
                          border={true}
                          textAlign="left"
                        >
                          {realEstatOccupancy[1]}
                        </s.ContentCell>
                      </s.Row>
                      <s.Row>
                        <s.TitleCell width="110px">점유관계</s.TitleCell>
                        <s.ContentCell
                          width="auto"
                          border={true}
                          textAlign="left"
                        >
                          {realEstatOccupancy[3]}
                        </s.ContentCell>
                      </s.Row>
                      <s.Row>
                        <s.TitleCell width="110px">기타</s.TitleCell>
                        <s.ContentCell
                          width="auto"
                          border={true}
                          textAlign="left"
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: cleanedString(
                                realEstatOccupancy[5] &&
                                  realEstatOccupancy[5][0]
                                  ? realEstatOccupancy[5][0]
                                  : '',
                              ),
                            }}
                          />
                        </s.ContentCell>
                      </s.Row>
                    </tbody>
                  </s.Table>
                </s.Content>
              </s.ContentBlock>
              {leaseSurvey && leaseSurvey.length > 0 && (
                <s.ContentBlock style={{ padding: '0 16px 16px', gap:0 }}>
                  <s.ContentTitleBox>임대차관계조사서</s.ContentTitleBox>
                  <s.Content>
                    <s.SubContentTitle>
                      1. 임차 목적물의 용도 및 임대차 계약등의 내용
                    </s.SubContentTitle>
                    {leaseSurvey.map((item, index) => (
                      <s.Table key={index}>
                        <tbody>
                          <s.Row>
                            <s.TitleCell width="160px">소재지</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="left"
                              colSpan={3}
                            >
                              {item[0] ?? '-'}
                            </s.ContentCell>
                          </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">점유인</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[2][0] ?? '-'}
                            </s.ContentCell>

                          </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">당사자구분</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[2][1] ?? '-'}
                            </s.ContentCell>
                          </s.Row>
                          
                            <s.Row>
                            <s.TitleCell width="160px">용도</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[4][1] ?? '-'}
                            </s.ContentCell>
                          </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">점유부분</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[4][0] ?? '-'}
                            </s.ContentCell>
                            </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">점유기간</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[6][0] ?? '-'}
                            </s.ContentCell>
                          </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">
                              보증(전세)금{' '}
                            </s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[8][0] ?? '-'}원
                            </s.ContentCell>
                          </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">차임</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[8][1] ?? '-'}원
                            </s.ContentCell>
                          </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">전입일자 </s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[10][0] ?? '-'}
                            </s.ContentCell>
                          </s.Row>
                          <s.Row>
                            <s.TitleCell width="160px">확정일자</s.TitleCell>
                            <s.ContentCell
                              width="auto"
                              border={true}
                              textAlign="center"
                            >
                              {item[10][1] ?? '-'}
                            </s.ContentCell>
                          </s.Row>
                        </tbody>
                      </s.Table>
                    ))}
                  </s.Content>
                </s.ContentBlock>
                )}
                </div>
            </>
          )}
          {tab === '부동산표시목록' && (
            <s.Content style={{ padding: '0 16px 40px 16px' }}>
              <s.ContentTitleBox style={{ padding:'24px 0 24px' }}>부동산표시목록</s.ContentTitleBox>
              <s.Table>
                <thead>
                  <s.Row>
                    <s.TableHeadTh
                      width="110px"
                      style={{ textAlign: 'left' }}>목록번호</s.TableHeadTh>
                     <s.ContentCell
                      width="auto"
                      border={true}
                      textAlign="left"
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: cleanedString(
                            displayList[1] && displayList[1][0]
                              ? displayList[1][0]
                              : '',
                          ),
                        }}
                      />
                    </s.ContentCell>
                  </s.Row>
                  <s.Row>
                    <s.TableHeadTh
                      width="110px"
                      style={{ textAlign: 'left' }}
                    >
                      목록구분</s.TableHeadTh>
                    <s.ContentCell
                      width="auto"
                      border={true}
                      textAlign="left"
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: cleanedString(
                            displayList[1] && displayList[1][1]
                              ? displayList[1][1]
                              : '',
                          ),
                        }}
                      />
                    </s.ContentCell>
                    </s.Row>
                    <s.Row>
                    <s.TableHeadTh
                      width="110px"
                      style={{ textAlign: 'left' }}
                    >상세내역</s.TableHeadTh>
                    <s.ContentCell width="auto" border={true} textAlign="left">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: formattedString(
                            displayList[1] && displayList[1][2]
                              ? displayList[1][2]
                              : '',
                          ),
                        }}
                      />
                    </s.ContentCell>
                  </s.Row>
                </thead>
              </s.Table>
            </s.Content>
          )}
        </s.Inner>
      )}
      <Footer/>
    </s.Container>
  );
};

export default StatusServey;

const TitleWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #70737C29;
`

const PageTitleBox = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  ;
`

const BackButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const IconWrapper  = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const DuplicationWrapper = styled.div`
  border: 1px solid #E1E2E4;
  padding: 16px;
  border-radius: 8px;
`
const DuplicationTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  line-height: 145%;
  border-radius: 8px;
  margin-bottom: 4px;
`

const DuplicationBox = styled.div`
  background: #F7F8FC;
  border-radius: 8px;
  padding: 10px 12px;
  position: relative;
  height: 40px;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
`